module.exports = __webpack_public_path__ + "static/img/model3@2x.cb4eefd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/model3@2x.png
// module id = 4PGg
// module chunks = 1